// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rule {\n  width: 100%;\n  border: 1px solid oklch(var(--b2));\n}\n", "",{"version":3,"sources":["webpack://./src/components/atoms/Rule/Rule.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kCAAkC;AACpC","sourcesContent":[".rule {\n  width: 100%;\n  border: 1px solid oklch(var(--b2));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
